<ng-template #content let-c="close" let-d="dismiss">
    <form name="frm" (submit)="onSubmit()">
        <div class="modal-header">
            <h6 class="modal-title"><span translate>LBL.UPLOAD_IMAGE</span></h6>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body callAttachment">
            <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>

            <div class="row align-items-center form-group no-gutters">
                <label class="col-4 col-form-label" translate>LBL.MAX_UPLOAD_SIZE</label>
                <div class="col-8 pl-2">&nbsp;{{MaximumImageSize}}</div>
            </div>

            <div class="row form-group">
                <label class="col-4 col-form-label" translate>LBL.UPLOAD_NEW_FILE</label>
                <div class="col-8">
                    <input type="file" [hidden]="true" #chooseFile class="custom-file" name="file"  (change)="onFileChanged($event)" title="{{'TITLE.TITLE_UPLOAD_FILE' | translate}}" multiple />
                    <button type="button" class="btn btn-default" (click)="chooseFile.click()">
                        {{'TITLE.TITLE_UPLOAD_FILE' | translate}}
                    </button>
                </div>
            </div>

             <div class="row border-top pt-3" *ngIf="_MasterConstants.IsImage(ImageObj.FileName)">
                <div class="col-4 mb-3">
                    <div>
                        <img  class="img-thumbnail" [src]="_sanitizer.bypassSecurityTrustUrl('' + ImageObj.Base64String)" />
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-primary" translate>BTN.BTN_OK</button>
            <button class="btn btn-secondary" (click)="d('Close')" translate>BTN.BTN_CANCEL</button>
        </div>
    </form>
</ng-template>
